export * from './src/favicon';
